import React, { useState } from "react";
import "./LeadsPage.css";
import industrialImg from "../assets/images/leadsPage.png";

const API_URL =
  process.env.REACT_APP_LEADS_API_URL || "http://localhost:4000/api/leads";

const LeadsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    location: "",
    companyName: "",
    comments: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (!response.ok) throw new Error("Failed to submit lead.");
      setSubmitted(true);
    } catch (err) {
      setError("Failed to submit. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="leads-page-wrapper">
      <div className="leads-layout">
        {/* LEFT — description + image */}
        <div className="leads-left">
          <div className="leads-description">
            <h2 className="leads-description-title">Become A VICON Partner</h2>
            <p>
              Explore dealership and distributor opportunities for refrigerator,
              AC, washing machine, microwave, and appliance spare parts.
            </p>
            <p>
              VICON offers a wide spare parts range with reliable supply support
              for dealers, retailers, and service networks.
            </p>
          </div>
          <img
            src={industrialImg}
            alt="VICON Partner"
            className="leads-image"
          />
        </div>

        {/* RIGHT — form */}
        <div className="leads-form-panel">
          {submitted ? (
            <div className="leads-success">
              Thank you for your interest!
              <br />
              Our team will connect with you shortly.
            </div>
          ) : (
            <form className="leads-form" onSubmit={handleSubmit}>
              <h2 className="leads-form-title">Enquire Now</h2>
              <div className="leads-form-row">
                <div className="leads-form-col">
                  <label>
                    Name:
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </label>
                  <label>
                    Contact Number:
                    <input
                      type="tel"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </label>
                  <label>
                    Email ID:
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
                <div className="leads-form-col">
                  <label>
                    Location:
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                    />
                  </label>
                  <label>
                    Company Name:
                    <input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      required
                    />
                  </label>
                  <label>
                    Comments:
                    <textarea
                      name="comments"
                      value={formData.comments}
                      onChange={handleChange}
                      required
                    />
                  </label>
                </div>
              </div>
              <div className="leads-form-submit-row">
                <button type="submit" disabled={loading}>
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </div>
              {error && <div className="leads-error">{error}</div>}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadsPage;
